import { Box } from "@mui/joy";
import DarkTypography from "../../../common/DarkTypography";
import IconButtonCTA from "../../../common/IconButtonCTA";
import { hrAccentColor } from "../../../../styles/globalStyles";
import { SCreate } from "../../../../styles/StyledMUI";

export type QualificationsToolbarProps = {
  canEdit: boolean;
  loading: boolean;
  isEditing: boolean;
  onAdd: () => void;
};

export default function QualificationsToolbar({
  canEdit,
  loading,
  isEditing,
  onAdd,
}: QualificationsToolbarProps) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        minWidth: 0,
        flexWrap: "wrap",
        gap: 1,
        mb: 1,
      }}
    >
      <DarkTypography level="title-md" sx={{ color: hrAccentColor }}>
        Qualifications
      </DarkTypography>
      {canEdit && (
        <IconButtonCTA
          aria-label="Ajouter une qualification"
          ctaVariant="accent"
          onClick={onAdd}
          disabled={loading || isEditing}
        >
          <SCreate />
        </IconButtonCTA>
      )}
    </Box>
  );
}
